import { Error } from '@/components/ui/error';
import { Loading } from '@/components/ui/loading';
import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from '@/components/ui/table';

import { useGlobalCurrencies } from '@/data/globalCurrencies';

const ListGlobalCurrencies = () => {
  const globalCurrencies = useGlobalCurrencies();

  if (globalCurrencies.isLoading && !globalCurrencies.data) {
    return <Loading />;
  }

  if (globalCurrencies.error) {
    return <Error message="An error occurred loading global currencies" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Symbol</TableHead>
          <TableHead>Code</TableHead>
          <TableHead>Label</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {globalCurrencies.data.query.map((globalCurrencyUid) => {
          const globalCurrency = globalCurrencies.data.content[globalCurrencyUid];
          return (
            <TableRow key={globalCurrencyUid}>
              <TableCell>{globalCurrency.symbol}</TableCell>
              <TableCell>{globalCurrency.code}</TableCell>
              <TableCell>{globalCurrency.label}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ListGlobalCurrencies;
